import debug from 'bows';
import Selectr from 'selectr';
import loader from './util/_loader';

const log = debug('staff');

class Staff {

	constructor(opts = {}) {
		this.defaultOpts = {
			wpJson: '/wp-json/',
			alpha: true
		}
		this.opts = {};

		for (var opt in opts) {
			this.opts[opt] = (opts.hasOwnProperty(opt) && typeof opts[opt] !== 'undefined') ? opts[opt] : this.defaultOpts[opt];
		}

		this.alphaGroups = {
			'A-F': 'ABCDEF'.split(''),
			'G-L': 'GHIJKL'.split(''),
			'M-Q': 'MNOPQ'.split(''),
			'R-W': 'RSTUVW'.split(''),
			'X-Z': 'XYZ'.split('')
		}
		this.alphaGroupKeys = Object.keys(this.alphaGroups);

		this.departments = {};

		const select = document.querySelector('select.selectr');
		if (select) {
			this.selectr = new Selectr('select.selectr', {
				placeholder: 'Select One',
				defaultSelected: false,
				allowDeselect: true
			});

			this.selectr.on('selectr.change', (option) => {
				this.filter(option.value);
			});
		}

		this.loading = false;
		this.opened = false;
		this.cache = {};

		this.template = `
			<div class="staff__modal-content">
				<div class="staff__modal-col1">
					<figure class="staff__modal-figure staff__modal-figure--desktop">
						<img src="{{image}}" alt="{{title}}">
					</figure>
					<div class="staff__modal-quote--desktop">
						{{quote}}
					</div>
				</div>
				<div class="staff__modal-col2">
					<a href="#modal-close" class="staff__modal-close">&times;</a>
					<h3 class="staff__modal-name">{{display_name}}</h3>
					<p class="staff__modal-title"><strong>{{title}}</strong></p>
					<hr class="hr--short hr--left">

					<figure class="staff__modal-figure staff__modal-figure--mobile">
						<img src="{{image}}" alt="{{title}}">
					</figure>
					<div class="staff__modal-quote--mobile">
						{{quote}}
					</div>

					{{content}}
				</div>
			</div>
		`.trim();

		this.modal = document.createElement('div');
		this.modal.classList.add('staff__modal');
		this.modal.addEventListener('click', (e) => {
			if (e.target.matches('a[href="#modal-close"]') || e.target === this.modal) {
				e.preventDefault();
				this.close();
			}
		});
		document.body.addEventListener('keyup', this.keyup.bind(this));

		this.list = document.querySelector('.staff__list-content');
		this.members = Array.from(document.querySelectorAll('.staff__member'));

		this.loader = document.createElement('div');
		this.loader.classList.add('staff__loader');
		this.loader.insertAdjacentHTML('beforeend', loader);

		if (this.members.length) {
			this.list.addEventListener('click', (e) => {
				if (this.loading === true) {
					return;
				}

				let node = e.target;
				while (!node.matches('.staff__member')) {
					if (node === this.list) {
						e.stopPropagation();
						return;
					}
					node = node.parentNode;
				}

				this.load( node );
			});

			this.members.forEach((member) => {
				const departments = member.dataset.departments.trim().split(' ');
				departments.forEach((dpmnt) => {
					if (!this.departments[dpmnt]) {
						this.departments[dpmnt] = [];
					}
					this.departments[dpmnt].push(member);
				});
			});
		}

		if (this.opts.alpha) {
			log('alpha', this.opts.alpha);
			this.nav = document.querySelector('.staff__nav');
			this.navItems = Array.from(document.querySelectorAll('.staff__nav .staff__nav-item'));
			if (this.navItems.length) {
				this.nav.addEventListener('click', (e) => {
					let node = e.target;
					while (!node.matches('.staff__nav-item a')) {
						if (node === this.nav) {
							e.stopPropagation();
							return;
						}
						node = node.parentNode;
					}

					e.preventDefault();
					this.paginate(node);
				});

				this.navPrevious = this.navItems.filter((item) => item.matches('.staff__nav-item--prev')).shift();
				this.navNext = this.navItems.filter((item) => item.matches('.staff__nav-item--next')).shift();
			}

			let activeGroup = this.navItems.filter((item) => item.classList.contains('staff__nav-item--active'));
			if (activeGroup) {
				this.paginate(activeGroup.shift().querySelector('a'), true);
			}
		} else {
			this.showAll();
		}

		if (window.location.hash) {
			let openMember = document.querySelector(`.staff__member[data-slug="${window.location.hash.substr(1)}"]`);
			log(openMember);
			if (openMember) {
				this.load(openMember);
			}
		}

		document.body.classList.add('staff--active');
	}

	load(member) {
		if (this.cache[member.dataset.id]) {
			this.open(member);
			return;
		}

		const promise = new Promise((resolve, reject) => {
			member.classList.add('staff__member--loading');
			member.appendChild(this.loader);
			this.loading = true;

			const endpoint = `${(member.dataset.national === '1') ? '/wp-json/' : this.opts.wpJson}wp/v2/staff/${member.dataset.id}`;

			const xhr = new XMLHttpRequest();
			xhr.open('GET', endpoint);
			xhr.addEventListener('load', () => {
				if (xhr.status >= 200 && xhr.status < 300) {
					const data = JSON.parse(xhr.responseText);
					resolve(data);
				} else {
					reject('HTTP Error');
				}
			});

			log('promise', xhr);
			xhr.send();
		}).then((data) => {
			console.log(data);
			this.cache[member.dataset.id] = data;
			member.classList.remove('staff__member--loading');
			this.loader.parentNode.removeChild(this.loader);
			this.loading = false;

			this.open(member);
		}).catch((e) => {
			log(e);
		});
	}

	open( member ) {
		console.log(this.cache[member.dataset.id]);

		const data = this.cache[member.dataset.id];

		let tpl = new String(this.template);
		tpl = tpl.replace(/{{title}}/g, data.staff_data.title)
			.replace(/{{image}}/g, data.staff_data.image)
			.replace(/{{content}}/g, data.content.rendered)
			.replace(/{{display_name}}/g, data.staff_data.display_name)
			.replace(/{{thumbnail}}/g, data.staff_data.thumbnail)
			.replace(/{{quote}}/g, data.staff_data.quote)
			.replace(/{{(.*)}}/g, '');

		this.modal.insertAdjacentHTML('beforeend', tpl);

		this.opened = true;
		document.body.appendChild(this.modal);
		document.documentElement.style.overflow = 'hidden';

		setTimeout(() => {
			this.modal.style.opacity = 1;
		}, 5);
	}

	close() {
		let transend = () => {
			this.modal.innerHTML = '';
			this.modal.parentNode.removeChild(this.modal);
			this.modal.removeEventListener('transitionend', transend);
		}

		this.opened = false;
		this.modal.addEventListener('transitionend', transend);
		this.modal.style.opacity = 0;
		document.documentElement.style.overflow = '';
	}

	keyup(e) {
		if (e.which === 27 && this.opened) {
			this.close();
			document.body.removeEventListener('keyup', this.keyup.bind(this));
		}
	}

	filter(department) {
		log('filter', department);
		this.members.forEach((member) => {
			if (this.departments[department].indexOf(member) > -1) {
				member.classList.add('staff__member--active');
			} else {
				member.classList.remove('staff__member--active');
			}
		});

		this.navPrevious.classList.add('staff__nav-item--disabled');
		this.navNext.classList.add('staff__nav-item--disabled');

		this.navItems.filter((item) => item.classList.contains('staff__nav-item--active')).forEach((item) => {
			item.classList.remove('staff__nav-item--active');
		});
	}

	paginate(node, showPriority = false) {
		let group = node.hash.replace(/^#staff-/, '').toUpperCase();

		if (group === 'PREVIOUS' || group === 'NEXT') {
			let alphaGroupIndex = this.alphaGroupKeys.indexOf(this.activeGroup);
			group = this.alphaGroupKeys[((group === 'NEXT') ? alphaGroupIndex + 1 : alphaGroupIndex - 1)];

			if (group < 0) {
				group = this.alphaGroupKeys[0];
			} else if (group >= this.alphaGroupKeys.length) {
				group = this.alphaGroupKeys[this.alphaGroupKeys.length - 1];
			}
		}

		this.activeGroup = group;
		this.activeGroupIndex = this.alphaGroupKeys.indexOf(this.activeGroup);

		this.members.forEach((member) => {
			if (this.alphaGroups[this.activeGroup].indexOf(member.dataset.group) > -1 || (showPriority === true && member.classList.contains('staff__member--priority'))) {
				member.classList.add('staff__member--active');
			} else {
				member.classList.remove('staff__member--active');
			}
		});

		this.navItems.filter((item) => item.classList.contains('staff__nav-item--active')).forEach((item) => {
			item.classList.remove('staff__nav-item--active');
		});

		this.navItems.filter((item) => item.dataset.group === this.activeGroup).forEach((item) => {
			item.classList.add('staff__nav-item--active');
		});

		this.navItems.filter((item) => item.matches('.staff__nav-item--disabled')).forEach((item) => {
			item.classList.remove('staff__nav-item--disabled');
		});

		if (this.activeGroup === this.alphaGroupKeys[0]) {
			this.navPrevious.classList.add('staff__nav-item--disabled');
			this.navNext.classList.remove('staff__nav-item--disabled');
		} else if (this.activeGroupIndex === this.alphaGroupKeys.length - 1) {
			this.navPrevious.classList.remove('staff__nav-item--disabled');
			this.navNext.classList.add('staff__nav-item--disabled');
		} else {
			this.navPrevious.classList.remove('staff__nav-item--disabled');
			this.navNext.classList.remove('staff__nav-item--disabled');
		}

		if (this.selectr) {
			this.selectr.reset('');
		}
		log(window.pageYOffset, this.list.getBoundingClientRect().top, window.pageYOffset + this.list.getBoundingClientRect().top);

		let scrollTo = window.pageYOffset + this.list.getBoundingClientRect().top;
		if (scrollTo < document.documentElement.scrollTop) {
			window.scrollTo( 0,  scrollTo);
		}

		log('paginate', node, group, this.alphaGroups[this.activeGroup]);
	}

	showAll() {
		this.members.forEach((member) => {
			member.classList.add('staff__member--active');
		});
	}
}

export default Staff;
